import { useMutation, useQueryClient } from "@tanstack/react-query";
import { marcheazaNotificareCitita } from "@/api/endpoints/notificari";
import { queryKeys } from "@/lib/queryClient";

export function useMarcheazaNotificareCitita() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: marcheazaNotificareCitita,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.notificari.recalcul(),
      });
    },
  });
}
